import { Link } from "react-router-dom";

export interface PillButtonProps {
  children: React.ReactNode;
  variant?: "primary" | "outline" | "white";
  onClick?: () => void;
  href?: string;
  className?: string;
}

export default function PillButton({
  children,
  variant = "primary",
  onClick,
  href,
  className = "",
}: PillButtonProps) {
  const baseClass = variant === "primary"
    ? "btn-pill-primary"
    : variant === "outline"
    ? "btn-pill-outline"
    : "btn-pill-white";

  if (href) {
    const isExternal = href.startsWith("http://") || href.startsWith("https://") || href.startsWith("mailto:");
    if (isExternal) {
      return (
        <a href={href} className={`${baseClass} ${className}`} onClick={onClick}>
          {children}
        </a>
      );
    }
    const handleClick = () => {
      window.scrollTo(0, 0);
      onClick?.();
    };
    return (
      <Link to={href} className={`${baseClass} ${className}`} onClick={handleClick}>
        {children}
      </Link>
    );
  }

  return (
    <button className={`${baseClass} ${className}`} onClick={onClick}>
      {children}
    </button>
  );
}